import { Text } from '@approvalmax/ui/src/components';
import { domain } from 'modules/data';
import { FC, memo } from 'react';

import { TextCellProps } from './TextCell.types';

const TextCell: FC<TextCellProps> = memo((props) => {
    const { value, status } = props;

    const inactive = status !== domain.CompanyUserStatus.Active;

    return (
        <Text ellipsis={1} title={value} color={inactive ? 'midnight60' : 'black100'} font='body' fontSize='small'>
            {value}
        </Text>
    );
});

export default TextCell;
